import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface Toast { id: string; message: string; type: 'success' | 'error' | 'info' | 'warning'; }

interface UiState {
  sidebarOpen: boolean;
  toasts:      Toast[];
  activeModal: string | null;
}

const uiSlice = createSlice({
  name: 'ui',
  initialState: { sidebarOpen: true, toasts: [], activeModal: null } as UiState,
  reducers: {
    toggleSidebar: (state) => { state.sidebarOpen = !state.sidebarOpen; },
    addToast:  (state, action: PayloadAction<Omit<Toast, 'id'>>) => {
      state.toasts.push({ ...action.payload, id: Date.now().toString() });
    },
    removeToast:  (state, action: PayloadAction<string>) => {
      state.toasts = state.toasts.filter(t => t.id !== action.payload);
    },
    openModal:  (state, action: PayloadAction<string>) => { state.activeModal = action.payload; },
    closeModal: (state) => { state.activeModal = null; },
  },
});

export const { toggleSidebar, addToast, removeToast, openModal, closeModal } = uiSlice.actions;
export default uiSlice.reducer;
